// extracted by mini-css-extract-plugin
var _1 = "Header_header__FLgF2";
export { _1 as "header" }
